var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hide),expression:"hide"}],staticClass:"headway-widget-selector pull-right hidden-print"},[_c('span',{staticClass:"anchor"})])}
var staticRenderFns = []

export { render, staticRenderFns }